import React, { useState } from 'react'
import { auth } from '../../Config/Config'
import { Link } from 'react-router-dom'

export const AdminLogin = (props) => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');  

    const Semail = 'admin@gmail.com'; 

    const Spassword = "admin1234"

    const login = (e) => {
        e.preventDefault(); 

         if(Semail === email && Spassword === password) { 
            props.history.push('/admin/addProducts');
         } else { 
             setError("Email or Password is incorrect"); 
         }
        // auth.signInWithEmailAndPassword(email, password).then(() => {
        //     setEmail('');
        //     setPassword('');
        //     setError('');
      
        // }).catch(err => setError(err.message));
    } 

    return (
        <div className='container'>
            <br />
            <h2>Administrator</h2>
            <br />
            <form autoComplete="off" className='form-group' onSubmit={login}>
                <label htmlFor="email">Email</label>
                <input type="email" className='form-control' required
                    onChange={(e) => setEmail(e.target.value)} value={email} />
                <br />
                <label htmlFor="password">Password</label>
                <input type="password" className='form-control' required
                    onChange={(e) => setPassword(e.target.value)} value={password} />
                <br />
                <button type="submit" className='btn btn-success btn-md mybtn'>LOGIN</button>
            </form>
            {error && <span className='error-msg'>{error}</span>}
            <br/>
            <span> Only for administrators.
            </span>
        </div>
    );
}
